export const ASSETS = {
  logos: {
    main: {
      path: 'assets/unicorn-logo.png',
      width: 120,
      height: 48
    },
    mainLarge: {
      path: 'assets/unicorn-logo-large.png',
      width: 320,
      height: 320
    },
    favicon: {
      path: 'public/favicon.svg',
      width: 32,
      height: 32
    }
  },
  avatars: {
    user1: {
      path: 'https://randomuser.me/api/portraits/men/32.jpg',
      width: 40,
      height: 40
    },
    user2: {
      path: 'https://randomuser.me/api/portraits/women/44.jpg',
      width: 40,
      height: 40
    },
    user3: {
      path: 'https://randomuser.me/api/portraits/men/75.jpg',
      width: 40,
      height: 40
    },
    user4: {
      path: 'https://randomuser.me/api/portraits/women/68.jpg',
      width: 40,
      height: 40
    },
    user5: {
      path: 'https://randomuser.me/api/portraits/men/52.jpg',
      width: 40,
      height: 40
    }
  },
  icons: {
    trophy: {
      path: 'assets/trophy-icon.png',
      width: 24,
      height: 24
    },
    code: {
      path: 'assets/code-icon.png',
      width: 24,
      height: 24
    },
    clock: {
      path: 'assets/clock-icon.png',
      width: 24,
      height: 24
    },
    user: {
      path: 'assets/user-icon.png',
      width: 24,
      height: 24
    }
  }
};
